import * as React from 'react';
import Pagination from '../pagination';
import { useTheme } from '@veneer/theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TablePagination = _ref => {
  var {
    pagination
  } = _ref;
  var theme = useTheme();
  var styles = React.useMemo(() => {
    return {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingTop: theme.orbitalFour
    };
  }, [theme]);
  return ___EmotionJSX("div", {
    css: styles
  }, ___EmotionJSX(Pagination, pagination));
};
TablePagination.displayName = 'TablePagination';
export default TablePagination;